.previousOrderContainer {
  padding: 24px;

  @media (--reefer-media-tablet-max) {
    padding: 16px;
  }
}

.previousOrderButtons {
  flex-direction: row;

  @media (--reefer-media-tablet-max) {
    flex-direction: column;
  }
}
